import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService, { type ImportFinancingsRequest } from '../services/capitalMarketsService';

export default function useImportFinancings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ImportFinancingsRequest) => capitalMarketsService.importFinancings(payload),
    onError: (error: any) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      const errorMessages: Record<number, string> = {
        400: 'IDs de financiamento inválidos.',
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
        404: 'Recurso não encontrado.',
      };

      const errorMessage = errorMessages[status] || message || 'Erro inesperado ao importar financiamentos.';
      toast.error(errorMessage);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['financings', 'filter'] });
    },
    retry: 1,
    retryDelay: 1000,
  });
}
